import React from 'react';
import './App.css';

// Import all components
import Navigation from './components/Navigation';
import Home from './components/Home';
import Carousel from './components/Carousel';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      // fallback: scroll to top so user isn't left confused if element is missing
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleCallClick = () => {
    window.location.href = 'tel:+918778030302';
  };

  return (
    <div className="App">
      {/* Navigation Bar */}
      <Navigation scrollToSection={scrollToSection} />

      {/* Home Section */}
      <Home scrollToSection={scrollToSection} />

      <div className="content-background">
        <About />
        <Services />
        <Gallery />
        <Carousel />
        <Contact />
        <Footer />
      </div>

      {/* Floating Book/Call Buttons */}
      <div className="floating-book-button">
        <button
          type="button"
          className="floating-action-btn floating-action-btn--call"
          onClick={handleCallClick}
        >
          Call Now
        </button>
        
      </div>
    </div>
  );
}

export default App;
